"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateUrlSafeRandom = generateUrlSafeRandom;
function generateUrlSafeRandom(params) {
    var length = params.length;
    // Compute required byte length before encoding
    var byteLength = Math.ceil((length * 3) / 4);
    var crypto = window.crypto || window.msCrypto;
    var array = new Uint8Array(byteLength);
    crypto.getRandomValues(array);
    // Encode and apply Base64URL transformations
    var base64url = btoa(String.fromCharCode.apply(String, __spreadArray([], __read(array), false)))
        .replace(/\+/g, "-") // Base64URL encoding
        .replace(/\//g, "_")
        .replace(/=+$/, ""); // Remove padding
    // Trim or regenerate if too short
    if (base64url.length > length) {
        return base64url.substring(0, length);
    }
    else if (base64url.length < length) {
        // If trimming removes too much, recursively generate more
        return base64url + generateUrlSafeRandom({ length: length - base64url.length });
    }
    return base64url;
}
//# sourceMappingURL=generateUrlSafeRandom.js.map